import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, matchValue: string, replaceWith: string): string {
    if (!value) {
      return value;
    }
    const regex = new RegExp(matchValue, 'g');
    return value.replace(regex, replaceWith);
  }
}